import React from "react";
import { Stack, MultiSelect } from "@mantine/core";

export type BrandOption = { id: number; title: string };
export type VehicleOption = { id: number; name: string };

type BrandVehicleSelectProps = {
  availableBrands: BrandOption[];
  availableVehicles: VehicleOption[];
  brandIds: number[];
  vehicleIds: number[];
  onBrandsChange: (ids: number[]) => void;
  onVehiclesChange: (ids: number[]) => void;
};

/**
 * Multi-select marques + vehicules (D-08 : granularite Marque ET Vehicule).
 * UI-SPEC §B : deux <MultiSelect searchable clearable> Mantine, pas de nouvelle
 * dependance lourde. `data` vient du controleur (available_brands / available_vehicles).
 */
const BrandVehicleSelect: React.FC<BrandVehicleSelectProps> = ({
  availableBrands,
  availableVehicles,
  brandIds,
  vehicleIds,
  onBrandsChange,
  onVehiclesChange,
}) => {
  const brandData = availableBrands.map((b) => ({
    value: String(b.id),
    label: b.title,
  }));
  const vehicleData = availableVehicles.map((v) => ({
    value: String(v.id),
    label: v.name,
  }));

  return (
    <Stack gap="md">
      <MultiSelect
        label="Marques"
        placeholder="Sélectionner des marques…"
        data={brandData}
        value={brandIds.map(String)}
        onChange={(vals) => onBrandsChange(vals.map(Number))}
        searchable
        clearable
      />
      <MultiSelect
        label="Véhicules"
        placeholder="Sélectionner des véhicules…"
        data={vehicleData}
        value={vehicleIds.map(String)}
        onChange={(vals) => onVehiclesChange(vals.map(Number))}
        searchable
        clearable
      />
    </Stack>
  );
};

export default BrandVehicleSelect;
